import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import Editor from 'react-simple-wysiwyg';
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';
import Member from "./v1/components/member";
import ErrorPage from "../../pages/error";
import InfoFile from "./v1";


function InfoProfilePage(props){

    // QUESTIONS

    const items = [
        "Часткова обстановка на об’єкті та в районі розташування об’єкта.",
        "Назва об’єкта, його призначення і належність до відповідного відомства (хто є власником об’єкта)",
        "Значення об’єкта в загальній системі галузі, його залежність від інших підприємств галузі, характер продукції, що виробляється, потужності з випуску продукції в мирний час (воєнний час), реальний стан виробництва.",
        "Точне місцезнаходження об’єкта, його складові елементи та місце їх розташування (за можливості додати схеми та фотознімки).",
        "Керівний склад та його характеристика (біографічні дані, ділові та моральні якості, звички, хобі тощо).",
        "Наявність спеціалізованих конструкторських бюро, наукових підрозділів, лабораторій, випробувальної бази тощо.",
        "Значення об’єкта в загальній системі галузі, його залежність від інших підприємств галузі, характер продукції, що виробляється, потужності з випуску продукції в мирний час (воєнний час), реальний стан виробництва:",
        "Фінансова система об’єкта, його прибутковість, розміри грошового забезпечення працівників, порядок оплати праці.",
        "Організація таємного діловодства, порядок оформлення допуску до роботи з секретними документами та відомостями. Місця розташування таємних частин (де зберігаються секретні матеріали), особи, відповідальні за режим секретності (періодичність проведення контрольних заходів).",
        "Система охорони об’єкта, ступінь його забезпечення технічними засобами охорони, організація перепускного режиму, зразки перепусток.",
        "Система зв’язку, номери телефонів у системі міського зв’язку. Система внутрішнього зв’язку (список абонентів).",
        "Організація цивільної оборони на об’єкті:",
        "Під’їзні шляхи. Система постачання водою, газом та електричною енергією:",
        "Найбільш вразливі місця об’єкта, шляхи прихованого підходу та відходу (в разі потреби):",
        "Місцезнаходження та коротка характеристика суміжних та інших об’єктів (зокрема, улюблені місця відпочинку співробітників):",
        "Порядок підбору кадрів та оформлення на роботу, порядок посадових переміщень, звільнення. Можливі шляхи влаштування на роботу, вимоги до кандидатів на заміщення вакантних посад:",
        "Структурні підрозділи, де циркулюють відомості, що становлять інтерес для розвідки:",
        "Відомості про осіб, які мають доступ до конфіденційних відомостей на об’єкті:",
        "Відомості про осіб, які можуть допомогти у працевлаштуванні на об’єкт:",
    ];

    const labelNotFound = 'Інформація відсутня';

    const placeholder = `<br>
       <p><b>1. ${items[0]}</b><br>${labelNotFound}</p><br>
       <p><b>2. ${items[1]}</b><br>${labelNotFound}</p><br>
       <p><b>3. ${items[2]}</b><br>${labelNotFound}</p><br>
       <p><b>4. ${items[3]}</b><br>${labelNotFound}</p><br>
       <p><b>5. ${items[4]}</b><br>${labelNotFound}</p><br>
       <p><b>6. ${items[5]}</b><br>${labelNotFound}</p><br>
       <p><b>7. ${items[6]}</b><br>${labelNotFound}</p><br>
       <p><b>8. ${items[7]}</b><br>${labelNotFound}</p><br>
       <p><b>9. ${items[8]}</b><br>${labelNotFound}</p><br>
       <p><b>10. ${items[9]}</b><br>${labelNotFound}</p><br>
       <p><b>11. ${items[10]}</b><br>${labelNotFound}</p><br>
       <p><b>12. ${items[11]}</b><br>${labelNotFound}</p><br>
       <p><b>13. ${items[12]}</b><br>${labelNotFound}</p><br>
       <p><b>14. ${items[13]}</b><br>${labelNotFound}</p><br>
       <p><b>15. ${items[14]}</b><br>${labelNotFound}</p><br>
       <p><b>16. ${items[15]}</b><br>${labelNotFound}</p><br>
       <p><b>17. ${items[16]}</b><br>${labelNotFound}</p><br>
       <p><b>18. ${items[17]}</b><br>${labelNotFound}</p><br>
       <p><b>19. ${items[18]}</b><br>${labelNotFound}</p><br>
       <p><b>Висновки і пропозиції.</b>  Обґрунтувати доцільність організації та
                                        здійснення операції з агентурного проникнення на об’єкт (вказати характер
                                        відомостей, які цікаві для розвідки, найбільш доцільний спосіб
                                        агентурного проникнення на об’єкт, залежно від обраного способу
                                        визначити шлях впровадження).<br>Інформація відсутня</p><br>
        <p>На теперішній час вважаю за доцільне:</p>
        <br>
    `;

    //TODO: MEMBERS

    const [members, setMembers] = useState([
        // {
        //     photo: "",
        //     posada: "",
        //     pib: "",
        //     work: "",
        //     note: ""
        // }
    ]);

    const memberAdd = () => {
        setMembers([...members,  {
            photo: "",
            posada: "",
            pib: "",
            work: "",
            note: ""
        }]);
    }

    const memberRemove = (i) => {
        setMembers([
            ...members.slice(0, i),
            ...members.slice(i + 1)
        ]);
    }

    const memberHandleChange = (i, e, field) => {
        const values = [...members];
        values[i][field] = e.target.value;
        setMembers(values);
    }

    function memberHandleChangePhoto(i, e) {
        const values = [...members];
        values[i].photo = URL.createObjectURL(e.target.files[0]);
        setMembers(values);
    }

    // CHECK AUTH

    if([0, '', null, undefined].includes(localStorage.getItem('uid'))){
        return <ErrorPage />
    }

    return <div id={'info-file-page'} className={'container vh-100 d-flex align-items-center justify-content-center'}>

        <div className="container">

            <div className="top-header d-flex align-items-center">
                <Link to={'/projects'} className={'btn btn-light'}>
                   <ArrowLeft /> Назад
                </Link>
                <h4 className={'p-1'}>
                    Information File
                    <small className="text-muted m-2">
                       v.1.0
                    </small>
                </h4>
            </div>

            <div id={'content'} className="overflow-scroll pb-3 p-2" style={{height: "90vh"}}>

                <InfoFile init={placeholder} />

            </div>
        </div>

    </div>

}

export default InfoProfilePage;
